import type { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinanceInvoiceRoutes = defineRoute({
    record: {
        route: {
            path: "/finance-invoice",
            component: () => loadView(import("./FinanceInvoiceTable.vue")),
        },
        build(filter?: { status?: Enums.InvoiceStatusEnum.Values }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/finance-invoice?&filter=${encoded}`;
            }

            return "/finance-invoice";
        },
    },
    create: {
        route: {
            path: "/finance-invoice/create",
            component: () => loadView(import("./FinanceInvoiceCreate.vue")),
        },
        debug: true,
    },
    detail: {
        route: {
            path: "/finance-invoice/detail/:id",
            component: () => loadView(import("./FinanceInvoiceDetail.vue")),
        },
        build(id: string) {
            return `/finance-invoice/detail/${id}`;
        },
    },
});
